const tableTitleTableActions = {
  title: 'Ações Geradas',
  placeholder: 'Pesquisar pelos campos: ID, ação, problema, questão',
};

export default tableTitleTableActions;
